import { DateTime } from 'luxon';
import { Modalidade } from '../..';
import { Fixture } from '../fixture.types';
import { Configs, OpcoesAjuda } from './config.types';

export const configFixture: Fixture<Configs> = () => {
  const mock: Configs = {
    contexto: 'https://aluno-frontend.estaciodev.net',
    ambiente: 'test',
    marca: 'estacio',
    idClienteEnsineme: 'A39EAE23-8E99-27B8-82FC-D5ABAF8953CD',
    API: 'https://hmlapi.estacio.br/desenv/aura',
    API_DEDICADA: 'https://apis.educador.estacio.br/rest',
    API_V2: 'https://hmlapi.estacio.br/desenv/aura-frontend',
    URL_QC: 'https://app-master-lms.qcx-dev.com',
    URL_REDIRECT_ENSINEME: 'https://stecine.azureedge.net/repositorio/redirect/_redirect.html',
    URL_EDUCADOR: 'https://educador-frontend.estaciodev.net',
    URL_FAQ: '/aura-repo/estacio/faq-estudante.pdf',
    URL_MANUAL: '/aura-repo/estacio/manual-estudante.pdf',
    URL_BASE_CALENDARIO_ACADEMICO: '/aura-repo/calendario-academico/',
    EXTENSOES_VALIDAS_ENVIO_ARQUIVO: ['pdf', 'jpg'],
    userManagerSettings: {
      authority: 'https://login.microsoftonline.com/da49a844-e2e3-40af-86a6-c3819d704f49/v2.0/',
      client_id: 'df3220df-48f5-4da4-ad37-b84c73985dc5',
      redirect_uri: 'http://localhost:3000',
      post_logout_redirect_uri: 'http://localhost:3000',
      monitorSession: false,
      userStore: null,
      prompt: 'select_account',
      response_type: 'code',
      automaticSilentRenew: true,
      loadUserInfo: false,
      scope: 'df3220df-48f5-4da4-ad37-b84c73985dc5/.default',
    },
    GTM_ID: 'GTM-56HT2PR',
    TAMANHO_PAGINA_RESPOSTA_TRABALHOS: 1,
    BIBLIOTECA_VIRTUAL: [
      {
        title: 'Repositório de Livros Próprios',
        url: 'https://repositorio.novatech.net.br',
        descricao: 'Biblioteca de livros próprios da Estácio',
      },
      {
        title: 'Pergamum - Pesquisa de Acervo',
        url: 'http://biblioteca.estacio.br/pergamum/biblioteca/index.php',
        descricao: '',
      },
    ],
    CALENDARIO_ACADEMICO: [
      {
        titulo: '[EAD] 2021.1',
        url: '/aura-repo/calendario-academico/2021.1_EAD_NA_NA.pdf',
      },
      {
        titulo: '[EAD] 2021.2',
        url: '/aura-repo/calendario-academico/2021.2_EAD_NA_NA.pdf',
      },
    ],
    OPCOES_MENU_AJUDA: [
      {
        titulo: 'FAQ Digital',
        url: '/aura-repo/marcas/estacio/faq/faq-digital-estudante.pdf',
        tagGA: 'faq',
        modalidade: Modalidade.TOTAL_EAD,
        tipo: OpcoesAjuda.FAQ,
      },
      {
        titulo: 'FAQ Digital',
        url: '/aura-repo/marcas/estacio/faq/faq-digital-estudante.pdf',
        tagGA: 'faq',
        modalidade: Modalidade.FLEX_ESPECIAL,
        tipo: OpcoesAjuda.FAQ,
      },
      {
        titulo: 'FAQ Presencial/Semi/AoVivo',
        url: '/aura-repo/marcas/estacio/faq/faq-presencial-estudante.pdf',
        tagGA: 'faq',
        modalidade: Modalidade.PRESENCIAL,
        tipo: OpcoesAjuda.FAQ,
      },
      {
        titulo: 'FAQ Presencial/Semi/AoVivo',
        url: '/aura-repo/marcas/estacio/faq/faq-presencial-estudante.pdf',
        tagGA: 'faq',
        modalidade: Modalidade.SEMIPRESENCIAL,
        tipo: OpcoesAjuda.FAQ,
      },
      {
        titulo: 'FAQ Presencial/Semi/AoVivo',
        url: '/aura-repo/marcas/estacio/faq/faq-presencial-estudante.pdf',
        tagGA: 'faq',
        modalidade: Modalidade.AO_VIVO,
        tipo: OpcoesAjuda.FAQ,
      },
      {
        titulo: 'Jornada do Aluno Digital',
        url: 'https://super.abril.com.br/wp-content/uploads/2020/09/04-09_gato_SITE.jpg?quality=70&strip=info&resize=680,453',
        tagGA: 'manual-de-uso',
        tipo: OpcoesAjuda.MANUAL,
        modalidade: Modalidade.TOTAL_EAD,
      },
      {
        titulo: 'Jornada do Aluno Digital',
        url: 'https://super.abril.com.br/wp-content/uploads/2020/09/04-09_gato_SITE.jpg?quality=70&strip=info&resize=680,453',
        tagGA: 'manual-de-uso',
        tipo: OpcoesAjuda.MANUAL,
        modalidade: Modalidade.FLEX_ESPECIAL,
      },
      {
        titulo: 'Jornada do Aluno Presencial/Semi/AoVivo',
        url: 'https://alunoestacio.myportfolio.com/',
        tagGA: 'manual-de-uso',
        tipo: OpcoesAjuda.MANUAL,
        modalidade: Modalidade.PRESENCIAL,
      },
      {
        titulo: 'Jornada do Aluno Presencial/Semi/AoVivo',
        url: 'https://alunoestacio.myportfolio.com/',
        tagGA: 'manual-de-uso',
        tipo: OpcoesAjuda.MANUAL,
        modalidade: Modalidade.SEMIPRESENCIAL,
      },
      {
        titulo: 'Jornada do Aluno Presencial/Semi/AoVivo',
        url: 'https://alunoestacio.myportfolio.com/',
        tagGA: 'manual-de-uso',
        tipo: OpcoesAjuda.MANUAL,
        modalidade: Modalidade.AO_VIVO,
      },
    ],
    ONBOARDING_MODALIDADE: {
      modalidades: ['EAD', 'FLEX'],
      slides: [
        {
          cabecalho: {
            titulo: 'titulo-cabecalho',
            descricao: 'descricao-cabecalho',
          },
          corpo: {
            titulo: 'Menu geral da plataforma:',
            descricao: 'Aqui você pode acessar as principais áreas de navegação.',
            tipo: 'YOUTUBE',
            conteudo: {
              desktop: 'Hbny&h',
              mobile: 'Hbny&h',
            },
          },
        },
      ],
    },
    ONBOARDING_PLATAFORMA: {
      slides: [
        {
          cabecalho: {
            titulo: 'titulo-cabecalho',
            descricao: 'descricao-cabecalho',
          },
          corpo: {
            titulo: 'Menu geral da plataforma:',
            descricao: 'Aqui você pode acessar as principais áreas de navegação.',
            tipo: 'IMAGEM',
            conteudo: {
              desktop: '/assets/images/onboarding/estacio/desk-01.png',
              mobile: '/assets/images/onboarding/estacio/mob-01.png',
            },
          },
        },
        {
          cabecalho: {
            titulo: 'titulo-cabecalho',
            descricao: 'descricao-cabecalho',
          },
          corpo: {
            titulo: 'Informações da turma:',
            descricao: 'Aqui você encontra as informações completas da disciplina/turma.',
            tipo: 'IMAGEM',
            conteudo: {
              desktop: '/assets/images/onboarding/estacio/desk-02.png',
              mobile: '/assets/images/onboarding/estacio/mob-02.png',
            },
          },
        },
        {
          cabecalho: {
            titulo: 'titulo-cabecalho',
            descricao: 'descricao-cabecalho',
          },
          corpo: {
            titulo: 'Linha do tempo de temas:',
            descricao: 'Veja onde encontrar a linha do tempo de temas da disciplina.',
            tipo: 'IMAGEM',
            conteudo: {
              desktop: '/assets/images/onboarding/estacio/desk-03.png',
              mobile: '/assets/images/onboarding/estacio/mob-03.png',
            },
          },
        },
        {
          cabecalho: {
            titulo: 'titulo-cabecalho',
            descricao: 'descricao-cabecalho',
          },
          corpo: {
            titulo: 'Conteúdo da disciplina:',
            descricao: 'Ao clicar no card, você tem acesso ao conteúdo digital da disciplina.',
            tipo: 'IMAGEM',
            conteudo: {
              desktop: '/assets/images/onboarding/estacio/desk-04.png',
              mobile: '/assets/images/onboarding/estacio/mob-04.png',
            },
          },
        },
        {
          cabecalho: {
            titulo: 'titulo-cabecalho',
            descricao: 'descricao-cabecalho',
          },
          corpo: {
            titulo: 'Conteúdo complementar ou atividades:',
            descricao: 'Aqui você encontra conteúdos ou atividades disponibilizados pelo professor.',
            tipo: 'IMAGEM',
            conteudo: {
              desktop: '/assets/images/onboarding/estacio/desk-05.png',
              mobile: '/assets/images/onboarding/estacio/mob-05.png',
            },
          },
        },
        {
          cabecalho: {
            titulo: 'titulo-cabecalho',
            descricao: 'descricao-cabecalho',
          },
          corpo: {
            titulo: 'Menu de Ajuda:',
            descricao: 'Ao final do menu você encontra respostas para as perguntas mais frequentes.',
            tipo: 'IMAGEM',
            conteudo: {
              desktop: '/assets/images/onboarding/estacio/desk-06.png',
              mobile: '/assets/images/onboarding/estacio/mob-06.png',
            },
          },
        },
      ],
    },
    URL_BDQ_ALUNO: 'https://simulado.estacio.br/alunos/',
    URL_BDQ_EDUCADOR: 'https://simulado.estacio.br/docentes/',
    URL_TERMS: '/aura-repo/terms.pdf',
    bemVindoLogin: {
      texto1: 'Olá, Aluno.',
      texto2: 'Que bom ter você de volta!',
    },
    descricaoAcessoLogin: {
      texto1: 'Clique abaixo para acessar.',
      texto2: 'Seu e-mail de acesso é:',
      texto3: 'suamatricula@alunos.estacio.br',
    },
    headerMenuBiblioteca: 'Biblioteca Virtual',
    headerMenuCalendario: 'Calendário Acadêmico',
    labelEntrega: 'Disciplina',
    labelEntregas: 'Disciplinas',
    tooltipoMenuBdq: ' Sistema de Avaliações',
    tooltipoMenuEntregas: 'Turmas',
    headerMenuEmpregabilidade: 'Carreiras',
    avaliacao: {
      tiposAvaliacao: [
        {
          nome: 'PREPARA_EAD',
          titulo: 'Prepara EAD',
          descricao:
            'O Prepara EAD é uma lista de 10 questões para você exercitar o seu conhecimento e se preparar para a AV ou AVS. Ao realizar o Prepara você também ganha 5 horas de atividade complementar (AAC).',
        },
        {
          nome: 'TESTE_DE_CONHECIMENTO',
          titulo: 'Testes de Conhecimento',
          descricao:
            'Os Testes de Conhecimento são exercícios sobre os temas abordados para você reforçar seu aprendizado e se preparar para as avaliações. Lembre-se que esses testes não valem nota.',
        },
        {
          nome: 'SIMULADO',
          titulo: 'Simulados',
          descricao:
            'Os Simulados são exercícios na forma de testes. Eles abrangem o conteúdo da disciplina e podem adicionar até 2,0 pontos extras na AV ou AVS.',
        },
        {
          nome: 'AVALIACAO',
          titulo: 'Avaliações',
          descricao:
            'As avaliações são compostas por 10 questões e valem até 10 pontos. A AVS pode ser realizada para substituir a nota da AV, caso tenha obtido a nota mínima (6) ou queira melhorar a sua nota.',
        },
      ],
    },
    ITENS_MENU: [
      'home',
      'disciplinas',
      'biblioteca-virtual',
      'empregabilidade',
      'calendario-academico',
      'ajuda',
      'exercicios',
      'avaliacoes',
      'campus-sia',
      'acessibilidade',
    ],
    ITENS_AVALIACOES: [
      {
        tipo: 'simulado',
        dataInicio: DateTime.now(),
        dataFim: DateTime.now().plus({ days: 1 }),
      },
    ],
  };

  // Retorna o valor de uma propriedade do objeto principal
  const getValorProp = <K>(param: string): K => mock[param];

  // Retorna um clone do objeto principal com a propriedade param alterada
  const setValorAlternativo = (objeto, props): Configs => ({
    objeto,
    ...props,
  });

  // Retorna um clone do objeto principal
  const get = (): Configs => ({ ...mock });

  return { getValorProp, setValorAlternativo, get };
};
